import { OrderPriceBreakdown } from './delivery/order-price-breakdown/order-price-breakdown.component.js'

export default {
  OrderPriceBreakdown,
}
